<template>
    <div class="modal-content">

        <!-- Escolher Forma de Entrega -->
        <template v-if="endPagina == 'tipos' " >
            <div class="modal-header">
                <h5 class="modal-title" >Finalizar Compra</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body p-0">

                <div class="card mx-0">
                    <div class="card-header">
                        <h4 class="card-title">Como vai ser a forma de entrega?</h4>
                    </div>
                    <div class="card-body">
                        <!-- Retirar no Balcão -->
                         <template v-if="inquilino.entrega_balcao">
                             <div class="d-flex flex-row my-3">
                                 <div class="custom-control custom-radio">
                                     <input type="radio" id="balcao" name="entrega" class="custom-control-input" value=1 v-model.number="form.entrega_id">
                                     <label class="custom-control-label" for="balcao">Vou retirar no Balcão  </label><i class="ml-2 fas fa-info-circle" data-toggle="collapse" href="#collapseBalcao" role="button" aria-expanded="false" aria-controls="collapseBalcao"></i>
                                 </div>
                                 <div class="ml-auto">
                                     <div style="width:110px; text-align: center ">
                                         <span >Frete R$ 0,00</span>

                                     </div>
                                 </div>
                             </div>
                             <div class="collapse" id="collapseBalcao">
                                 <div class="card text-white bg-info card-body">
                                     Essa opção permite que você faça o pedido através do aplicativo VSMenu e retire a sua refeição diretamente no balcão do restaurante. É uma opção prática e rápida, ideal para quem não tem muito tempo disponível ou prefere não esperar pela entrega.
                                 </div>
                             </div>
                             <hr>
                         </template>
                        <!-- Comer no Local -->
                        <template v-if="inquilino.entrega_local">
                             <div class="d-flex flex-row my-3">
                                 <div class="custom-control custom-radio">
                                     <input type="radio" id="local" name="entrega" class="custom-control-input" value=3 v-model.number="form.entrega_id">
                                     <label class="custom-control-label" for="local">Vou comer no local</label> <i class="ml-2 fas fa-info-circle" data-toggle="collapse" href="#collapseLocal" role="button" aria-expanded="false" aria-controls="collapseLocal"></i>
                                 </div>
                                 <div class="ml-auto">
                                     <div style="width:110px; text-align: center ">
                                         <span >Frete R$ 0,00</span>

                                     </div>
                                 </div>
                             </div>
                             <div class="collapse" id="collapseLocal">
                                 <div class="card text-white bg-info card-body">
                                     Essa opção permite que você faça o pedido através do aplicativo VSMenu e consuma a sua refeição no próprio restaurante. É uma ótima opção para quem quer experimentar novos sabores e ambientes, além de poder contar com o atendimento personalizado e o ambiente acolhedor do estabelecimento.
                                 </div>
                             </div>
                             <hr>
                        </template>

                        <!-- Entregar -->
                        <template v-if="inquilino.entrega_endereco">



                            <div class="d-flex flex-row my-3">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="endereco" name="entrega" class="custom-control-input" value=2 v-model.number="form.entrega_id">
                                    <label class="custom-control-label" for="endereco">Entregue no meu endereço</label> <i class="ml-2 fas fa-info-circle" data-toggle="collapse" href="#collapseEndereco" role="button" aria-expanded="false" aria-controls="collapseEndereco"></i>
                                </div>
                                <div class="ml-auto" v-if="Object.keys(endereco_ativo).length != 0">
                                    <div v-if="!carregando" style="width:110px; text-align: center ">
                                        <span >Frete R$ {{ formatarMoeda(frete_endereco) }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="collapse" id="collapseEndereco">
                                <div class="card text-white bg-info card-body">
                                    Essa opção permite que você faça o pedido através do aplicativo VSMenu e receba a sua refeição no conforto da sua casa, escritório ou onde estiver. É uma opção prática e cômoda, ideal para quem quer desfrutar das delícias do restaurante sem precisar sair de casa ou se deslocar até o estabelecimento.
                                </div>
                            </div>

                            <div v-if="Object.keys(endereco_ativo).length != 0" class="d-flex flex-row my-3">

                                <span > {{
                                    endereco_ativo.logradouro+ ', '+
                                    endereco_ativo.numero+', '+
                                    ((endereco_ativo.complemento!=null)?endereco_ativo.complemento+', ':'')+
                                    endereco_ativo.bairro_nome+', '+
                                    endereco_ativo.cidade_nome+' - CEP: '+
                                    endereco_ativo.cep+
                                    ((endereco_ativo.referencia!=null)?' - '+endereco_ativo.referencia+', ':'') }}
                                </span>
                                <a class="btn b-btn " role="button" @click="endPagina = 'enderecos'"> trocar endereço</a>
                            </div>

                            <div v-else class="text-center" >
                                <p>endereço não cadastrado</p>
                                <a class="btn b-btn " role="button" @click="endPagina = 'enderecos'"> Cadastrar novo endereço</a>
                            </div>

                            <hr>




                        </template>


                        <div v-if="carregando" class="text-center">
                            <div class="spinner-border text-info my-5" role="status">
                                <span class="sr-only">Calculando Frete ...</span>
                            </div>
                            <p>Calculando Frete</p>
                        </div>

                        <template v-else>

                            <!-- Card Valor -->
                            <div v-if="form.entrega_id == 2 && faz_entrega == false " class="card mt-4">
                                <div class="alert alert-danger" role="alert">
                                    <strong>
                                        Lamentamos informar que, no momento, não realizamos entregas em sua região.
                                    </strong> <br>
                                    Estamos trabalhando para expandir nossa área de cobertura e esperamos atender você em breve.
                                    Agradecemos a sua compreensão!

                                </div>
                            </div>

                            <div v-else class="card mt-4">
                                <div class="card-body">

                                    <table class="table">
                                        <tr v-if="form.entrega_id==2">
                                            <th>Valor dos itens:</th>
                                            <td class="text-right">R$ {{ formatarMoeda(valorItens) }}</td>
                                        </tr>
                                        <tr v-if="form.entrega_id==2">
                                            <th>Frete</th>
                                            <td class="text-right">R$ {{ formatarMoeda(form.frete) }}</td>
                                        </tr>
                                        <tr>
                                            <th><h3>Valor Total:</h3></th>
                                            <td class="text-right"><h3>R$ {{ formatarMoeda(valorItens+form.frete) }}</h3></td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
                        </template>




                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal">Fechar</button>
                <button type="submit" class="btn b-btn" v-bind:disabled="form.entrega_id == null || (form.entrega_id == 2 && (faz_entrega == false || form.endereco_id == null ))" v-on:click="dispararEvento">Prosseguir para Pagamento</button>
            </div>
        </template>

        <!--
        ------------------------------------------------------------------------------------------------------------------------------------------
        ------------------------------------------------- Escolher Endereços ---------------------------------------------------------------------
        ------------------------------------------------------------------------------------------------------------------------------------------
        -->

        <template v-if="endPagina == 'enderecos' " >

            <div class="modal-header">
                <h5 class="modal-title" >Endereço de entrega</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>


            <div class="modal-body text-center">

                <template v-if="enderecos.length > 0">

                    <h3>Endereços salvos</h3>

                    <div class="row" v-for="endereco in enderecos">

                        <div class="col d-flex flex-row">
                            <div class="card-456 mr-2 align-self-start" @click="excluirEndereco(endereco.id)">
                                <span >
                                    X
                                </span>
                            </div>

                            <div class="card-123" @click="selecionarEndereco(endereco)">
                                <h4>{{ endereco.nome }}</h4>
                                <span > {{
                                    endereco.logradouro+ ', '+
                                    endereco.numero+', '+
                                    ((endereco.complemento!=null)?endereco.complemento+', ':'')+
                                    endereco.bairro_nome+', '+
                                    endereco.cidade_nome+' - CEP: '+
                                    endereco.cep+
                                    ((endereco.referencia!=null)?' - '+endereco.referencia+', ':'')}}
                                </span>

                            </div>
                        </div>
                    </div>

                    <div v-if="carregando" class="modal-body text-center">
                        <div class="spinner-border text-info my-5" role="status">
                            <span class="sr-only">carregando...</span>
                        </div>
                    </div>



                    <hr>
                </template>


                <a class="btn btn-lg b-btn " role="button" @click="endPagina = 'endereco-digitar'"> Digitar endereço</a>

                <hr>

                <a class="btn btn-lg b-btn " role="button" @click="endPagina = 'localizacao'"> Usar minha localização </a>


            </div>

            <div class="modal-footer">
                <a class="btn b-btn " role="button" @click="endPagina = 'tipos'"> voltar</a>
            </div>


        </template>

        <!--
        ------------------------------------------------------------------------------------------------------------------------------------------
        ------------------------------------------------- Usar Localização -----------------------------------------------------------------------
        ------------------------------------------------------------------------------------------------------------------------------------------
        -->

        <template v-if="endPagina == 'localizacao' " >

            <div class="modal-header">
                <h5 class="modal-title" >Minha Localização</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">

                <fc-map v-on:map-endereco="abrirFormulario" tipo="minha_licalização"></fc-map>

                <br><br>


            </div>

            <div class="modal-footer">
                <a class="btn b-btn " role="button" @click="endPagina = 'tipos'"> voltar</a>
            </div>


        </template>

        <!--
        ------------------------------------------------------------------------------------------------------------------------------------------
        ------------------------------------------------- Formulario - Confirmar Endereço  -------------------------------------------------------
        ------------------------------------------------------------------------------------------------------------------------------------------
        -->

        <template v-if="endPagina == 'formulario' " >

            <div class="modal-header">
                <h5 class="modal-title" >Confirmar Endereço</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div v-if="carregando" class="modal-body text-center">
                <div class="spinner-border text-info my-5" role="status">
                    <span class="sr-only">Verificando áreas de entrega...</span>
                </div>
                <p>Verificando áreas de entrega...</p>
            </div>

            <div v-else class="modal-body">

                <template v-if="formNovoEnderecoEditMode">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label">Rua:</label>
                        <div class="col-sm-8">
                            <input type="text"
                                autoComplete="off"
                                name="rua"
                                v-model="formNovoEndereco.rua"
                                class="form-control form-control-lg"
                                :class="{ 'is-invalid': formNovoEndereco.errors.has('rua') }">
                            <has-error :form="formNovoEndereco" field="rua"></has-error>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label">Bairro:</label>
                        <div class="col-sm-8">
                            <input type="text"
                                autoComplete="off"
                                name="bairro"
                                v-model="formNovoEndereco.bairro"
                                class="form-control form-control-lg"
                                :class="{ 'is-invalid': formNovoEndereco.errors.has('bairro') }">
                            <has-error :form="formNovoEndereco" field="bairro"></has-error>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label">Cidade:</label>
                        <div class="col-sm-8">
                            <input type="text"
                                autoComplete="off"
                                name="cidade"
                                v-model="formNovoEndereco.cidade"
                                class="form-control form-control-lg"
                                :class="{ 'is-invalid': formNovoEndereco.errors.has('cidade') }">
                            <has-error :form="formNovoEndereco" field="cidade"></has-error>
                        </div>
                    </div>

                </template>

                <div v-else class="row">
                    <div class="col">
                        <div class="card mb-3">
                            <div class="card-body text-center">
                                <h3>Endereço</h3>
                                <p>{{ formNovoEndereco.rua }}, {{ formNovoEndereco.bairro }}, {{ formNovoEndereco.cidade }} - {{ formNovoEndereco.estado }} - cep: {{ formNovoEndereco.cep }}</p>
                                <a href="#" @click="formNovoEnderecoEditMode = true">alterar</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Numero:</label>
                    <div class="col-sm-8">
                        <input type="text"
                            autoComplete="off"
                            name="numero_end"
                            v-model="formNovoEndereco.numero"
                            class="form-control form-control-lg"
                            :class="{ 'is-invalid': formNovoEndereco.errors.has('numero') }">
                        <has-error :form="formNovoEndereco" field="numero"></has-error>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Complemento:</label>
                    <div class="col-sm-8">
                        <input type="text"
                            autoComplete="off"
                            name="complemento_end"
                            v-model="formNovoEndereco.complemento"
                            class="form-control form-control-lg"
                            :class="{ 'is-invalid': formNovoEndereco.errors.has('complemento') }">
                        <has-error :form="formNovoEndereco" field="complemento"></has-error>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Ponto de Referência:</label>
                    <div class="col-sm-8">
                        <input type="text"
                            autoComplete="off"
                            name="referencia_end"
                            v-model="formNovoEndereco.referencia"
                            class="form-control form-control-lg"
                            :class="{ 'is-invalid': formNovoEndereco.errors.has('referencia') }">
                        <has-error :form="formNovoEndereco" field="referencia"></has-error>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <h5>Salvar como:</h5>

                        <div class="row align-items-center">
                            <div class="col">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="nome-casa" name="nome-casa" class="custom-control-input" value="Casa" selected v-model="formNovoEndereco.nome">
                                    <label class="custom-control-label" for="nome-casa"> Casa </label>
                                </div>
                            </div>
                            <div class="col">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="nome-trabalho" name="nome-trabalho" class="custom-control-input" value="Trabalho" v-model="formNovoEndereco.nome">
                                    <label class="custom-control-label" for="nome-trabalho"> Trabalho </label>
                                </div>

                            </div>
                            <div class="col">
                                <a href="#" v-if="formNovoEndereco.nome == 'Casa' || formNovoEndereco.nome == 'Trabalho' " @click="formNovoEndereco.nome=''">outro</a>

                                <input type="text"
                                    v-else
                                    autoComplete="off"
                                    name="nome"
                                    v-model="formNovoEndereco.nome"
                                    class="form-control"
                                    placeholder="Digite"
                                    :class="{ 'is-invalid': formNovoEndereco.errors.has('nome') }">
                                <has-error :form="formNovoEndereco" field="nome"></has-error>
                            </div>
                        </div>

                    </div>
                </div>


            </div>

            <div class="modal-footer">
                <a class="btn btn-lg b-btn mr-auto" role="button" @click="endPagina = 'tipos'"> voltar</a>

                <a class="btn btn-lg b-btn " role="button" @click="confirmarEndereco"> Confirmar Endereco</a>
            </div>


        </template>

        <!--
        ------------------------------------------------------------------------------------------------------------------------------------------
        ------------------------------------------------- Formulario - Digitar Endereço  -------------------------------------------------------
        ------------------------------------------------------------------------------------------------------------------------------------------
        -->


        <template v-if="endPagina == 'endereco-digitar' ">

            <div class="modal-header">
                <h5 class="modal-title" >Pesquisar endereço</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <fc-map v-on:map-endereco="abrirFormulario" tipo="buscar"></fc-map>


            </div>

            <div class="modal-footer">
                <a class="btn btn-lg b-btn mr-auto" role="button" @click="endPagina = 'enderecos'"> voltar</a>
            </div>


        </template>



    </div>
</template>

<script>
import api from "../../service/api";
export default {

    props: ['inquilino', 'valorItens'],

    data () {
        return {
            carregando:false,
            endereco_ativo:null,
            enderecos:[],
            endPagina:"tipos",
            endereco_novo:null,

            faz_entrega: false,
            frete_endereco: 0,

            form: new Form({
                endereco_id: null,
                entrega_id: null,
                frete: '',
            }),

            formNovoEnderecoEditMode: false,

            formNovoEndereco: new Form({
                cep: "",
                pais: "",
                estado: "",
                uf: "",
                cidade: "",
                bairro: "",
                rua: "",
                lat: "",
                lng: "",
                numero: "",
                complemento: "",
                referencia: "",
                nome: "Casa",
                place_id: "",

            }),

            pesquisarEndereco: '',

            outro_nome: false,

        }
    },

    watch: {

        'form.entrega_id': function (n) {
            if (n!=2) {
                this.form.frete = 0;
                this.form.endereco_id = null ;
            }else if( Object.keys(this.endereco_ativo).length != 0){

                this.form.frete = this.frete_endereco;
                this.form.endereco_id = this.endereco_ativo.id ;
            }
        },

        'endereco_ativo.id': function (n) {

            this.calcularFrete(this.endereco_ativo);

            this.form.endereco_id = n ;
        },




    },

    computed: {

        endereco_formatado: function () {

            var end = this.endereco_ativo.logradouro+', '+this.endereco_ativo.numero+', '+(this.endereco_ativo.complemento?this.endereco_ativo.complemento+ ', ':'')+this.endereco_ativo.bairro_nome+', '+this.endereco_ativo.cidade_nome+' - '+this.endereco_ativo.uf+(this.endereco_ativo.referencia?' ('+this.endereco_ativo.referencia+ ') ':'');

            return end;
        }

    },

    methods: {

        async loadEndereco(){
            this.carregando = true;
            await api
            .get('/login-user/endereco-padrao')
            .then(response => (this.endereco_ativo = response.data));

            this.carregando = false;
        },

        async loadEnderecos(){

            this.carregando = true;
            await api
            .get('/login-user/enderecos')
            .then(response => (this.enderecos = response.data));

            this.carregando = false;
        },

        formatarMoeda(valor){
            return parseFloat(valor).toFixed(2).replace(".",",")
        },

        selecionarEndereco(endereco) {
            this.endereco_ativo = endereco;
            this.endPagina = "tipos";
            this.form.entrega_id = 2;
        },

        abrirFormulario(endereco){

            this.formNovoEndereco.fill(endereco);

            this.formNovoEndereco.nome = "Casa";
            this.formNovoEndereco.complemento = "";
            this.formNovoEndereco.referencia = "";

            this.endereco_novo = endereco;
            this.endPagina = "formulario";

        },

        async calcularFrete(endereco){


            await api
            .post('/calcular_frete',{
                endereco: endereco
            })
            .then(response => {
                if (response.data.error) {
                    this.frete_endereco = 0;
                    this.form.frete =  0;
                    this.faz_entrega = false;
                    this.carregando = false;
                }else{
                    this.frete_endereco = parseFloat(response.data.taxa_de_entrega);
                    this.form.frete =  parseFloat(response.data.taxa_de_entrega) ;
                    this.faz_entrega = true;
                }
            });

        },

        async confirmarEndereco(){

            this.carregando = true;

            var endereco = {
                "logradouro": this.formNovoEndereco.rua,
                "numero":  this.formNovoEndereco.numero,
                "bairro_nome":  this.formNovoEndereco.bairro,
                "cidade":  this.formNovoEndereco.cidade,
                "uf":  this.formNovoEndereco.uf,
            }

            await this.calcularFrete(endereco);

            if (this.faz_entrega) {

                let formData = new FormData();

                formData.append('nome', this.formNovoEndereco.nome);
                formData.append('bairro_id', 0);
                formData.append('cep', this.formNovoEndereco.cep);
                formData.append('logradouro', this.formNovoEndereco.rua);
                formData.append('numero', this.formNovoEndereco.numero);
                formData.append('complemento', this.formNovoEndereco.complemento);
                formData.append('referencia', this.formNovoEndereco.referencia);

                formData.append('cidade', this.formNovoEndereco.cidade);
                formData.append('uf', this.formNovoEndereco.uf);
                formData.append('bairro', this.formNovoEndereco.bairro);
                formData.append('pais', this.formNovoEndereco.pais);
                formData.append('lat', this.formNovoEndereco.lat);
                formData.append('lng', this.formNovoEndereco.lng);
                formData.append('google_place_id', this.formNovoEndereco.place_id);


                await api.post('/endereco',formData, { headers: {'Content-Type': 'multipart/form-data'}})
                .then((response) => {

                    if (response.data.success) {

                        this.$store.dispatch('fetchPerfil').then();

                        this.selecionarEndereco(response.data.endereco);

                        this.loadEnderecos();


                    }else{
                        this.formNovoEndereco.errors.errors =  response.data.error;

                        console.log('Não foi possivel atualizar!');
                    }

                })
                .catch(() => {
                    console.log('Algo deu errado!');
                });
            }else{


                this.selecionarEndereco(endereco);

            }

            this.carregando = false;


        },

        excluirEndereco(id){
            Swal.fire({
                title: 'Tem certeza que deseja excluir esse endereço?',
                text: "Você não poderá reverter isso!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim, pode excluir!'
            }).then((result) => {

                // Send request to the server
                if (result.value) {
                    this.carregando = true;
                    api.delete('/endereco/'+id).then(()=>{
                            Swal.fire(
                            'Deletado!',
                            'Seu Endereço foi excluído.',
                            'success'
                            );
                        this.$store.dispatch('fetchPerfil').then();
                        this.init();
                        this.carregando = false;
                    }).catch((data)=> {
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        },

        async init(){
            await this.loadEndereco();
            await this.loadEnderecos();
        },

        dispararEvento(){

            var obj = {
                pagina: "pagamento",
                endereco: {
                    entrega_id: this.form.entrega_id,
                    endereco_id: this.form.endereco_id,
                    frete: this.form.frete,
                    endereco_formatado: this.form.endereco_id!=null?this.endereco_formatado:null,
                }
            };

            this.$emit('componente-ativo', obj);
        }



    },

    async mounted() {

        await this.init();
    }



}
</script>

<style scoped>

.card-123{
    width:100%;
    margin: 10px 0;
    padding: 5px 15px;
    background-color: #d7ebe8;
    border-radius: 15px;
    cursor: pointer;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15), 0 4px 20px 0 rgba(0, 0, 0, 0.12);
}

.card-123:hover{
    background-color: #e1edeb;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25), 0 4px 20px 0 rgba(0, 0, 0, 0.19);
}

.card-456{
    color: #fff;
    margin: 10px 0;
    padding: 5px 15px;
    background-color: #990000;
    border-radius: 15px;
    cursor: pointer;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15), 0 4px 20px 0 rgba(0, 0, 0, 0.12);
}

.card-456:hover{
    background-color: #b60000;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25), 0 4px 20px 0 rgba(0, 0, 0, 0.19);
}


</style>
